/*
 * @Author: hbzyin hbzyin@163.com
 * @FilePath: /mall-fe/src/libs/features.ts
 * @Description: 环境开关变量文件 已废弃
 */
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

type timestamp = number;
interface Feature {
  enabled: boolean;
  dateRange?: [timestamp, timestamp];
}

interface Features {
  [name: string]: Feature;
}

/**
 * 全局功能开关变量枚举配置
 */
export enum FeatureEnum {
  TempFilter = 'TempFilter',
  Watermark = 'Watermark',
  JdRichText = 'JdRichText', // 京东对接商品富文本
  GjzqUpstreamParams = 'GjzqUpstreamParams', // 钢筋专区添加配送商参数 下个版本
  FreightConfig = 'FreightConfig', // 运费配置  2023/4/03
  QiDianService = 'QiDianService', // 企点客服系统接入 2023/04/03
  Agreement = 'Agreement', // 规则修改 2023/4/3
  FixShopSkuList = 'FixShopSkuList', // 修复店铺商品列表查询 2023/3/17
  AnnouncementModal = 'AnnouncementModal', // 进入首页时显示未读的公告 2023/03/24
  SelfBillDueDate = 'SelfBillDueDate', // 自营账单到期 2023/4/3
  AuditText = 'AuditText', // 审批 2023/4/3
  ChangeAMapKey = 'ChangeAMapKey',
  TodoMessage = 'TodoMessage', // 我的 -> 我的应用 -> 待办 2023/4/17
  AddLCZQ = 'AddLCZQ', // 首页添加聊城专区入口
  ToLoginRouter = 'ToLoginRouter', // 采购商和供应商跳转同一登录界面
  NewHomeChange = 'NewHomeChange', // 对外商城首页改版
  ServiceEntrance = 'ServiceEntrance', //客服入口优化
  TakeDelivery = 'TakeDelivery', //外部采购商实现简易收货
}

/**
 * 全局功能开关变量 是否打开 配置
 */
const features: Features = {
  [FeatureEnum.TempFilter]: {
    enabled: false || !!publicRuntimeConfig.TempFilter,
    // dateRange: [Date.parse("2020/4/4"), Date.parse("2020/4/4 23:59:59")],
  },
  [FeatureEnum.Watermark]: {
    enabled: false || !!publicRuntimeConfig.Watermark,
  },
  [FeatureEnum.JdRichText]: {
    enabled: false || !!publicRuntimeConfig.JdRichText,
  },
  [FeatureEnum.GjzqUpstreamParams]: {
    enabled: false || !!publicRuntimeConfig.GjzqUpstreamParams,
  },
  [FeatureEnum.QiDianService]: {
    enabled: true || !!publicRuntimeConfig.QiDianService,
  },
  [FeatureEnum.Agreement]: {
    enabled: true || !!publicRuntimeConfig.Agreement,
  },
  [FeatureEnum.FreightConfig]: {
    enabled: true || !!publicRuntimeConfig.FreightConfig,
  },
  [FeatureEnum.FixShopSkuList]: {
    enabled: true || !!publicRuntimeConfig.FixShopSkuList,
  },
  [FeatureEnum.AnnouncementModal]: {
    enabled: true || !!publicRuntimeConfig.AnnouncementModal,
  },
  [FeatureEnum.SelfBillDueDate]: {
    enabled: true || !!publicRuntimeConfig.SelfBillDueDate,
  },
  [FeatureEnum.AuditText]: {
    enabled: true || !!publicRuntimeConfig.AuditText,
  },
  [FeatureEnum.ChangeAMapKey]: {
    enabled: true || !!publicRuntimeConfig.ChangeAMapKey,
  },
  [FeatureEnum.TodoMessage]: {
    enabled: true || !!publicRuntimeConfig.TodoMessage,
  },
  [FeatureEnum.AddLCZQ]: {
    enabled: true || !!publicRuntimeConfig.AddLCZQ,
  },
  [FeatureEnum.ToLoginRouter]: {
    enabled: true || !!publicRuntimeConfig.ToLoginRouter,
  },
  [FeatureEnum.NewHomeChange]: {
    enabled: true || !!publicRuntimeConfig.NewHomeChange,
  },
  [FeatureEnum.ServiceEntrance]: {
    enabled: true || !!publicRuntimeConfig.ServiceEntrance,
  },
  [FeatureEnum.TakeDelivery]: {
    enabled: true || !!publicRuntimeConfig.TakeDelivery,
  },
};
/**
 * 开关变量配置是否打开
 * @param {FeatureEnum} name - 功能开关名称
 * @return {boolean}   - 开关变量是否打开
 */
export function isFeatureActive(name: FeatureEnum) {
  const feature = features[name];

  if (!feature?.enabled && !publicRuntimeConfig.ALL) return false;

  if (feature.dateRange) {
    const [start, end] = feature.dateRange;
    const now = Date.now();
    if (now < start || now > end) return false;
  }

  return true;
}
